import type { PoolPlatform } from '@/api/client'
import { useTargets } from '@/lib/queries'
import { Field, FieldGroup, Input, Select } from '@/ui'
import type { StepProps } from './StepTarget'

const ZONES = ['Asia/Seoul', 'Asia/Tokyo', 'America/Los_Angeles', 'America/New_York', 'Europe/London', 'UTC']

/** Step 4 — 보내기 설정: the daily limit, the send hours and, for Bluesky, who sends. */
export function StepSend({
  s,
  set,
  platform,
  groupCount,
  eligible,
}: StepProps & { platform: PoolPlatform | undefined; groupCount: number; eligible: number }) {
  const targets = (useTargets().data ?? []).filter((t) => t.platform === 'bluesky' && t.status === 'active')
  const zones = ZONES.includes(s.timezone) ? ZONES : [s.timezone, ...ZONES]
  return (
    <div className="space-y-5">
      <FieldGroup columns={2}>
        <Field label="발송 이름" required className="sm:col-span-2">
          <Input value={s.name} onChange={(e) => set({ name: e.target.value })} />
        </Field>
        <Field label="하루 한도" hint="1~30명. 직접 보내는 것도 센다.">
          <Input inputMode="numeric" value={s.daily} onChange={(e) => set({ daily: e.target.value })} />
        </Field>
        <Field label="시간대">
          <Select value={s.timezone} onChange={(e) => set({ timezone: e.target.value })}>
            {zones.map((z) => (
              <option key={z} value={z}>
                {z}
              </option>
            ))}
          </Select>
        </Field>
        <Field label="보내기 시작 (시)" hint="0~23">
          <Input inputMode="numeric" value={s.startHour} onChange={(e) => set({ startHour: e.target.value })} />
        </Field>
        <Field label="보내기 끝 (시)" hint="1~24">
          <Input inputMode="numeric" value={s.endHour} onChange={(e) => set({ endHour: e.target.value })} />
        </Field>
      </FieldGroup>
      {platform === 'bluesky' && (
        <Field label="보내는 Bluesky 계정" required hint={targets.length === 0 ? '쓸 수 있는 Bluesky 계정이 없다. 계정에서 먼저 연결한다.' : undefined}>
          <Select value={s.sender} onChange={(e) => set({ sender: e.target.value })}>
            <option value="">계정을 고른다</option>
            {targets.map((t) => (
              <option key={t.id} value={t.id}>
                {t.name}
              </option>
            ))}
          </Select>
        </Field>
      )}
      <div className="rounded-md bg-muted/60 p-3 text-table">
        <p>
          만들면 {eligible}명이 {groupCount}개 그룹으로 들어가고, 한 명씩 초안을 쓴다. 초안은 ‘승인 대기’에 쌓이고, 승인한 것만 나간다.
          {platform === 'bluesky'
            ? ' Bluesky는 승인한 뒤 시간과 한도에 맞춰 자동으로 나간다.'
            : ' Instagram은 복사한 뒤 DM 창을 열어 직접 보내고 “보냈어요”를 누른다.'}
        </p>
      </div>
    </div>
  )
}
